export default {
  getParametrosInteressados: state => {
    return { params: { ...state.filtroInteressados } }
  },

  getInteressadosSelecionado: state => {
    return state.interessadosSelecionados
  },

  getProcesso: state => {
    return state.processoCadastro
  },

  getDocumento: state => {
    return state.documentoCadastro
  },

  getDadosSessao: state => {
    return state.dadosSessao
  },

  getValorDefaultAutoComplete: state => {
    return state.valorDefaultAutoComplete
  },

  getDataTableChecked: state => {
    return state.dataTableChecked
  },

  getKeyTableChecked: state => {
    return state.keyTableChecked
  },

  getProcessosTramitacao: state => {
    return state.processosTramitacao
  }
}
